import { httpClient } from '../http/httpClient'
import { GetJourneysParams, GetJourneysResponse } from './types'

export async function getJourneys(params?: GetJourneysParams) {
  const { data } = await httpClient
    .get<GetJourneysResponse>('/journeys', { params })
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data
}
